import { IGetAllPesquisaSatisfacaoClienteUseCase } from "../../../presentation/useCases/read/get_all_pesquisa_satisfacao_cliente_use_case";
import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { PesquisaSatiscacaoClienteLista } from "../../models/pesquisa_satisfacao_cliente_lista";
import { IEntregaObrasRepository } from "../../repositories/entrega_obras_repositories";

/**
 * GetAllPesquisaSatisfacaoClienteUseCase
 */

export class GetAllPesquisaSatisfacaoClienteUseCase
  extends BasePaginatedUseCase<PesquisaSatiscacaoClienteLista>
  implements IGetAllPesquisaSatisfacaoClienteUseCase {
  constructor(private readonly repository: IEntregaObrasRepository) {
    super();
  }

  async getAllPesquisaSatisfacaoCliente(
    idSatisfacaoCliente: number | undefined,
    respondidaPor: string | null,
    data: Date | null,
    local: string | null,
    status: number | null,
    page: number,
    rowsPerPage: number,
  ): Promise<void> {
    if (idSatisfacaoCliente === undefined) throw new Error('Falha ao obter id de satisfação do cliente.');

    const result = await this.repository.getAllPesquisaSatisfacaoCliente(
      idSatisfacaoCliente,
      respondidaPor,
      data,
      local,
      status ?? 2,
      page,
      rowsPerPage,
    );

    this._items = result.items;
    this._totalItems = result.totalItems;
    this._currentPage = result.currentPage;
    this._pageSize = result.pageSize;
  }
}
